import { createRouter, createWebHistory } from 'vue-router';
import VinInputPage from '@/components/VinInputPage.vue';
import ChecklistCapturePage from '@/components/ChecklistCapturePage.vue';
import AuthenticateView from "@/components/AuthenticateView.vue";
import AdminPage from '@/components/AdminPage.vue';
import store from '../store'; // Vuexストアのインポート
import { ADMIN_COMPANY_CODE } from '../constants';

const routes = [
  {
    path: '/',
    name: 'VinInputPage',
    component: VinInputPage,
    beforeEnter: isAuthenticated,
    meta: { requiresAuth: true },
  },
  {
    path: '/capture',
    name: 'ChecklistCapturePage',
    beforeEnter: isAuthenticated,
    component: ChecklistCapturePage,
    meta: { requiresAuth: true },
  },
  {
    path: "/authenticate",
    name: "Authenticate",
    component: AuthenticateView,
  },
  {
    path: '/admin',
    name: 'AdminPage',
    component: AdminPage,
    beforeEnter: isAuthenticated,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

function isAuthenticated(to, from, next) {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.isAuthenticated) {
      next({
        path: "/authenticate",
        query: {
          nextPath: to.path,
        },
      });
    } else if (to.matched.some((record) => record.meta.requiresAdmin)) {
      if (store.getters.companyCode !== ADMIN_COMPANY_CODE) {
        next({ path: '/' });
      } else {
        next();
      }
    } else {
      next();
    }
  } else {
    next();
  }
}

export default router;